import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import InputMask from 'react-input-mask'
import { validateEmail, validatePhoneNoWith48 } from '../../../../Helpers/ValidatorHelper'
import { CheckBox } from 'devextreme-react/check-box'
import SelectBox from 'devextreme-react/select-box'
import { FaCheck, FaXmark } from 'react-icons/fa6'
import { DateBox } from 'devextreme-react'
import { useAuth } from '../../../../Providers/AuthProvider'
import { useUser } from '../../../../Providers/UserProvider'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../Components/LoadingSpinner'

const AddEditUserWithoutEHandelAccessModal = ({ show, onHide, user, handleDownloadUsers }) => {
    const eInvoiceTypeMap = [
        { code: 'N', label: 'Nie' },
        { code: 'T', label: 'Pdf+Link' },
        { code: 'L', label: 'Link' },
        { code: 'M', label: 'PdfMax' },
        { code: 'E', label: 'Edi' },
        { code: 'W', label: 'Pdf+Edi' },
        { code: 'K', label: 'Nr KSeF' },
    ]
    const invoiceAccessTypeMap = [
        { code: 0, label: 'Brak dostępu' },
        { code: 1, label: 'Wg kontrahenta (tylko Faktury)' },
        { code: 2, label: 'Wg NIP (tylko Faktury)' },
        { code: 3, label: 'Wg kontrahenta (tylko Zgłoszenia)' },
        { code: 4, label: 'Wg NIP (tylko Zgłoszenia)' },
        { code: 5, label: 'Wg kontrahenta (Faktury + Zgłoszenia)' },
        { code: 6, label: 'Wg NIP (Faktury + Zgłoszenia)' },
    ]

    let isEditMode = user && user.recNo ? true : false
    const { authState } = useAuth()
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrormessage] = useState(null)
    const [showExpiredDate, setShowExpiredDate] = useState(false)
    const { handleAddCustomerUserWithoutEHandelAcces, handleEditCustomerUserWithoutEHandelAcces } = useUser()
    const [userData, setUserData] = useState({
        name: '', surname: '', position: '', email: '', phoneNumber: null, address: '',
        city: '', postalCode: null, recNo: null, isEBuuletyn: false, isAssortCollector: false, isEOrderPickup: false, eInvoiceType: 'N', isInvoiceCollector: false,
        cell: '', department: '', isSendingReminders: false, expiredDate: null, custId: authState.custId, eInvoiceAccesType: 0, operatorUserCode: authState.user.kod,
        contactNumber: '', operatorLogin: authState.user.userLogin
    })

    useEffect(() => {
        if (!showExpiredDate) {
            setUserData(prev => ({
                ...prev,
                expiredDate: null
            }))
        }
    }, [showExpiredDate])

    useEffect(() => {
        if (user) {
            setUserData({
                name: user.name, surname: user.surname, position: user.position, email: user.email, phoneNumber: user.phoneNumber, address: user.address,
                city: user.city, postalCode: user.postalCode, recNo: user.recNo, isEBuuletyn: user.isEBuuletyn, isAssortCollector: user.isAssortCollector, isEOrderPickup: user.isEOrderPickup,
                eInvoiceType: user.eInvoiceType, isInvoiceCollector: user.isInvoiceCollector, cell: user.cell, department: user.department, isSendingReminders: user.isSendingReminders,
                expiredDate: user.expiredDate ? new Date(user.expiredDate) : null, custId: authState.custId, eInvoiceAccesType: user.eInvoiceAccesType, operatorUserCode: authState.user.kod,
                contactNumber: user.contactNumber, operatorLogin: authState.user.userLogin
            })
            if (user.expiredDate) {
                setShowExpiredDate(true)
            }
            else {
                setShowExpiredDate(false)
            }
        }
        else {
            const hasLocalNo = authState.selectedCustomerData.localNum && authState.selectedCustomerData.localNum.trim() != '' ? true : false
            const adress = `${authState.selectedCustomerData.street} ${authState.selectedCustomerData.houseNum} ${hasLocalNo ? ` / ${authState.selectedCustomerData.localNum}` : ''}`
            setUserData({
                name: '', surname: '', position: '', email: '', phoneNumber: null, address: adress,
                city: authState.selectedCustomerData.city, postalCode: authState.selectedCustomerData.zipCode, recNo: null, isEBuuletyn: false, isAssortCollector: false, isEOrderPickup: false, eInvoiceType: 'N', isInvoiceCollector: false,
                cell: '', department: '', isSendingReminders: false, expiredDate: null, custId: authState.custId, eInvoiceAccesType: 0, operatorUserCode: authState.user.kod,
                contactNumber: '', operatorLogin: authState.user.userLogin
            })
            setShowExpiredDate(false)
        }
        setErrormessage(null)
        setIsLoading(false)
    }, [user])

    const handleInputOnChange = (e) => {
        setUserData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const handleCheckBoxChange = (e) => {
        const fieldName = e.component.option('name')
        const newValue = e.value
        setUserData(prev => ({
            ...prev,
            [fieldName]: newValue
        }))
    }

    const validateData = () => {
        if (!userData.name || userData.name.trim() == '') {
            setErrormessage('Imie nie może być puste!')
            return false
        }
        if (!userData.surname || userData.surname.trim() == '') {
            setErrormessage('Nazwisko nie może być puste!')
            return false
        }
        if (!userData.email || userData.email.trim() == '' || !validateEmail(userData.email)) {
            setErrormessage('Niepoprawny adres e-mail!')
            return false
        }
        return true
    }

    const handleAcceptButtonClick = async () => {
        if (validateData()) {
            if (user && user.recNo) { //Edycja                
                if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 3) {
                    toast.warning('Brak uprawnień!')
                    return
                }
                else {
                    setIsLoading(true)
                    let res = await handleEditCustomerUserWithoutEHandelAcces(userData)
                    if (res) {
                        toast.success('Poprawnie edytowano kontakt')
                        await handleDownloadUsers()
                        onHide()
                    }
                    else {
                        toast.error('Błąd w trakcie edycji kontaktu!')
                    }
                    setIsLoading(false)
                }

            }
            else { //Dodaj nowy
                if (Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) < 2) {
                    toast.warning('Brak uprawnień!')
                    return
                }
                setIsLoading(true)
                let res = await handleAddCustomerUserWithoutEHandelAcces(userData)
                if (res) {
                    toast.success('Dodano nowy kontakt')
                    await handleDownloadUsers()
                    onHide()
                }
                else {
                    toast.error('Błąd w trakcie dodawania nowego kontaktu!')
                }
                setIsLoading(false)
            }
        }
    }

    const checkIsBlockEditPrimaryData = () => {
        let res = false
        if (isEditMode && user?.isEHandel) {
            res = true
        }
        return res
    }

    if (isLoading) {
        return <Modal size='lg' show={show} onHide={onHide} centered>
            <LoadingSpinner />
        </Modal>
    }
    return (<Modal size='lg' show={show} onHide={onHide} centered scrollable={true}>
        <Modal.Header closeButton={true}>
            <Modal.Title>{userData?.recNo ? 'Edycja kontaktu' : 'Dodaj kontakt'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <>
                <div className='row'>
                    <h3 className="checkbox-list-title">{t("user")}</h3>
                    <div className="col-6 d-flex">
                        <Form.Control name='name' placeholder='Imie' value={userData.name} onChange={handleInputOnChange} maxLength={15} disabled={checkIsBlockEditPrimaryData()} autoFocus required />
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                    <div className="col-6 d-flex">
                        <Form.Control name='surname' placeholder='Nazwisko' value={userData.surname} onChange={handleInputOnChange} disabled={checkIsBlockEditPrimaryData()} maxLength={30} autoFocus required />
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6 d-flex">
                        <Form.Control name='position' placeholder='Stanowisko' maxLength={25} value={userData.position} onChange={handleInputOnChange} autoFocus required />
                        <span>&nbsp;&nbsp;&nbsp;</span>
                    </div>
                </div>
                <div className="row mt-2">
                    <h3 className="checkbox-list-title mt-4">{t("contact_data")}</h3>
                    <div className="col-6 d-flex">
                        <Form.Control name='email' placeholder='Email' type='email' maxLength={60} value={userData.email} onChange={handleInputOnChange} disabled={checkIsBlockEditPrimaryData()} autoFocus required />
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                    <div className="col-6 d-flex">
                        {isEditMode && user?.isEHandel ?
                            (<Form.Control mask="+48 999 999 999" value={userData.phoneNumber} placeholder={t("phone")} disabled={true} />)
                            :
                            (<InputMask
                                mask="+48 999 999 999"
                                value={userData.phoneNumber}
                                onChange={handleInputOnChange}
                            >
                                {(inputProps) => (
                                    <Form.Control
                                        {...inputProps}
                                        placeholder={t("phone")}
                                        name='phoneNumber'
                                        required
                                    />
                                )}
                            </InputMask>)}
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12 d-flex mb-2">
                        <Form.Control name='address' placeholder='Adres' maxLength={60} value={userData.address} onChange={handleInputOnChange} autoFocus required />
                    </div>
                    <div className="col-6 d-flex">
                        <Form.Control name='city' placeholder='Miasto' maxLength={60} value={userData.city} onChange={handleInputOnChange} autoFocus required />
                    </div>
                    <div className="col-6 d-flex">
                        <InputMask
                            mask="99-999"
                            value={userData.postalCode}
                            onChange={handleInputOnChange}
                            name='postalCode'
                        >
                            {(inputProps) => (
                                <Form.Control
                                    {...inputProps}
                                    placeholder="Kod pocztowy"
                                />
                            )}
                        </InputMask>
                    </div>
                </div>
                <div className="row mt-2">
                    <h3 className="checkbox-list-title mt-4">Właściwości kontaktu</h3>
                    <div className="col-auto d-flex align-items-center">
                        <span>Odbiorca faktur:</span>
                        <CheckBox
                            className="custom-checkbox ms-2"
                            value={userData.isInvoiceCollector}
                            name='isInvoiceCollector'
                            onValueChanged={handleCheckBoxChange}
                        />
                    </div>
                    <div className="col-auto d-flex align-items-center">
                        <span>Odbiór towaru:</span>
                        <CheckBox
                            className="custom-checkbox ms-2"
                            value={userData.isAssortCollector}
                            name='isAssortCollector'
                            onValueChanged={handleCheckBoxChange}
                        />
                    </div>
                    <div className="row mt-3">
                        <div className="col-auto d-flex align-items-center">
                            <span>Data ważności upoważnienia</span>
                            <div className={`custom-switch ms-2 me-2 ${showExpiredDate ? "active" : ""}`} onClick={() => setShowExpiredDate(prev => !prev)}>
                                <div className="custom-switch-circle">
                                    {showExpiredDate ? <FaCheck className='primary-accent-color-text' /> : <FaXmark />}
                                </div>
                            </div>
                            <DateBox
                                value={userData.expiredDate}
                                displayFormat="yyyy-MM-dd"
                                type='date'
                                adaptivityEnabled={true}
                                acceptCustomValue={false}
                                visible={showExpiredDate}
                                onValueChanged={(e) => {
                                    setUserData(prev => ({
                                        ...prev,
                                        expiredDate: e.value
                                    }))
                                }}
                                width={150}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-auto d-flex align-items-center">
                            <span>Biuletyn</span>
                            <CheckBox
                                className="custom-checkbox ms-2"
                                value={userData.isEBuuletyn}
                                name='isEBuuletyn'
                                onValueChanged={handleCheckBoxChange}
                            />
                        </div>
                        <div className="col d-flex align-items-center">
                            <span>E odbiór zamówień</span>
                            <CheckBox
                                className="custom-checkbox ms-2"
                                value={userData.isEOrderPickup}
                                name='isEOrderPickup'
                                onValueChanged={handleCheckBoxChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mt-2 d-flex align-items-center">
                    <div className="col">
                        <span>E odbiór faktur:</span>
                        <SelectBox
                            dataSource={eInvoiceTypeMap}
                            valueExpr='code'
                            displayExpr="label"
                            className="ms-2"
                            value={userData.eInvoiceType}
                            placeholder='Wybierz'
                            onValueChanged={(e) => {
                                setUserData(prev => ({
                                    ...prev,
                                    eInvoiceType: e.value
                                }))
                            }}
                        />
                    </div>
                </div>
                <div className="row mt-2 d-flex align-items-center">
                    <div className="col">
                        <span>Portal efaktury:</span>
                        <SelectBox
                            dataSource={invoiceAccessTypeMap}
                            valueExpr='code'
                            displayExpr="label"
                            className="ms-2"
                            value={userData.eInvoiceAccesType}
                            placeholder='Wybierz'
                            onValueChanged={(e) => {
                                setUserData(prev => ({
                                    ...prev,
                                    eInvoiceAccesType: e.value
                                }))
                            }}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-4 d-flex align-items-center">
                        <Form.Control name='cell' placeholder='Komórka' maxLength={1} value={userData.cell} onChange={handleInputOnChange} autoFocus required />
                    </div>
                    <div className="col-4 d-flex align-items-center">
                        <Form.Control name='department' placeholder='Dział' maxLength={1} value={userData.department} onChange={handleInputOnChange} autoFocus required />
                    </div>
                    <div className="col-4 d-flex align-items-center">
                        <span>Wysyłka upomnień:</span>
                        <CheckBox
                            className="custom-checkbox ms-2"
                            value={userData.isSendingReminders}
                            name='isSendingReminders'
                            onValueChanged={handleCheckBoxChange}
                        />
                    </div>
                </div>
                <MarketingConsentComponent
                    user={user}
                    isEditMode={isEditMode}
                />
                <div className="col mt-4 d-flex">
                    <span className='error-text-color me-2'>*</span>
                    <span>Pole wymagane</span>
                </div>
                <div className="col mt-3">
                    <button className='btn-app-primary' onClick={() => handleAcceptButtonClick()}>{t("confirm")}</button>
                </div>
                <div className='d-flex align-items-center justify-content-center'>
                    <b className='error-text-color'>{errorMessage}</b>
                </div>
            </>
        </Modal.Body>
    </Modal>)
}

const MarketingConsentComponent = ({ user, isEditMode }) => {
    if (isEditMode) {
        return (<div className='row mt-2'>
            <h3 className="checkbox-list-title mt-4">Zgody marketingowe - tylko podgląd!</h3>
            <div className="col-3 d-flex align-items-center">
                <span>Zgoda marketingowa</span>
                <CheckBox className="custom-checkbox ms-2" value={user.marketingAgreement} readOnly={true} />
            </div>
            <div className="col-3 d-flex align-items-center">
                <span>Zgoda email</span>
                <CheckBox className="custom-checkbox ms-2" value={user.marketingEmail} readOnly={true} />
            </div>
            <div className="col-3 d-flex align-items-center">
                <span>Zgoda sms</span>
                <CheckBox className="custom-checkbox ms-2" value={user.marketingSms} readOnly={true} />
            </div>
            <div className="col-3 d-flex align-items-center">
                <span>Zgoda tel</span>
                <CheckBox className="custom-checkbox ms-2" value={user.marketingPhone} readOnly={true} />
            </div>
        </div>)
    }
}

export default AddEditUserWithoutEHandelAccessModal